/**
 * DraftBulkActions -- Bulk confirm/discard buttons for draft findings
 */

import { Button } from "@/components/ui";
import {
  useConfirmAllFindings,
  useDiscardAllDrafts,
} from "@/packages/features-shared";
import type { Id } from "@/packages/types";

interface DraftBulkActionsProps {
  checklistItemId: Id<"checklistItems">;
  draftCount: number;
}

export function DraftBulkActions({
  checklistItemId,
  draftCount,
}: DraftBulkActionsProps) {
  const confirmAllMutation = useConfirmAllFindings();
  const discardAllMutation = useDiscardAllDrafts();

  return (
    <div className="flex gap-2 pt-1">
      <Button
        variant="secondary"
        size="sm"
        onClick={() => confirmAllMutation.mutateAsync({ checklistItemId })}
        disabled={confirmAllMutation.isPending}
      >
        Confirm All ({draftCount})
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => discardAllMutation.mutateAsync({ checklistItemId })}
        disabled={discardAllMutation.isPending}
      >
        Discard All
      </Button>
    </div>
  );
}
